function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M150,38.49a85.2,85.2,0,0,0-77.48,50A8.5,8.5,0,0,0,88,95.5a68,68,0,0,1,130,28v5H81.51A16.54,16.54,0,0,0,65,145V245a16.54,16.54,0,0,0,16.51,16.52h137A16.54,16.54,0,0,0,235,245V123.49A85.1,85.1,0,0,0,150,38.49Zm68,206H82v-99H218v99Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M150,164.49a31,31,0,1,0,31,31A31,31,0,0,0,150,164.49Zm0,45a14,14,0,1,1,14-14A14,14,0,0,1,150,209.49Z"
});

var SvgLockOpen = function SvgLockOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock_open.82295cbc.svg";
export { ForwardRef as ReactComponent };